import sc from 'styled-components';
import {UnifonTheme} from '@phonectas/unifon-ui-kit';

export const StyledSection = sc.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 16px;
`;

export const StyledManus = sc.div<{ theme: UnifonTheme }>`
	background-color: rgba(222,233,251,0.5);
	border-left: 4px solid ${({theme}) => theme['palette'].primary};
	border-radius: 4px;
	padding: 12px 14px;
	font-size: 16px;
	line-height: 1.5;
	white-space: pre-line;
`;

export const StyledList = sc.ul`
	margin: 0;
	padding-left: 20px;
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const StyledTable = sc.table`
	width: 100%;
	border-collapse: collapse;
	font-size: 14px;

	th, td {
		text-align: left;
		padding: 6px 8px;
		border-bottom: 1px solid #e0e0e0;
	}

	th {
		font-weight: 600;
	}

	td.num, th.num {
		text-align: right;
	}

	tr.total td {
		font-weight: 600;
	}
`;

export const StyledFormGrid = sc.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
`;

export const StyledFooter = sc.div`
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 16px;
`;

export const StyledPickerRow = sc.div`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	gap: 12px;
`;
